module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-columns"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('ul', {
    staticClass: "columns"
  }, _vm._l((_vm.columns), function(column, index) {
    return (column.column_cover_wxlite) ? _c('li', {
      key: index,
      staticClass: "column is-one-third-tablet"
    }, [_c('a', {
      attrs: {
        "href": 'https://time.geekbang.org/column/intro/' + column.column_id,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": column.column_cover_wxlite,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrapper"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('h3', [_vm._v(_vm._s(column.column_title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(column.column_subtitle))])]), _vm._v(" "), _c('div', {
      staticClass: "profile"
    }, [_vm._v(_vm._s(_vm.getTime(column.article_ctime) + '《' + column.article_title + '》'))])])])]) : _vm._e()
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-title"
  }, [_c('h1', [_vm._v("讲堂")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "href": "https://time.geekbang.org/paid-content",
      "target": "_blank"
    }
  }, [_vm._v("查看更多>")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c51447e6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cardColumns.vue
// module id = 466
// module chunks = 1